export enum EDealType {
  Services = 'Services',
  Goods = 'Goods',
}
